import React from "react";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { DateDisplay } from "../../DateDisplay";
import { PowUserResponse } from "../../../models/Administration";
import { deleteUser } from "../../../services/api/userAdministration.api";
import { useHistory, Link } from "react-router-dom";
import { showSnack } from "../../../utils/component";
import { useSnackbar } from "notistack";
import { toUserListPage, toUserEditPage } from "../../../router/navigation";

interface UserDisplayCardProps {
	//The pow user to display the details for.
	user: PowUserResponse;
}

const useStyles = makeStyles((theme) => ({
	card: {
		borderRadius: theme.spacing(0.5),
		width: "100%",
	},
	buttons: {
		fontSize: 11,
		fontWeight: 700,
		letterSpacing: ".15em",
		justifyContent: "space-between",
	},
	deleteButton: {
		marginLeft: theme.spacing(2),
	},
	title: {
		fontSize: 12,
		fontWeight: 700,
		letterSpacing: ".1em",
	},
	cardContent: {
		padding: theme.spacing(1),
	},
}));

/**
 * Takes in a PowUserResponse from PDP and displays basic information on that user
 * along with displaying a button allowing the option to delete the user or upon clicking
 * on the user name leading to the user edit page.
 * @param props
 */
export const UserDisplayCard = (props: UserDisplayCardProps) => {
	const classes = useStyles();
	const history = useHistory();
	const { enqueueSnackbar } = useSnackbar();

	const handleDeleteButtonClick = async () => {
		try {
			await deleteUser(props.user.userPrincipalName)();
			history.push(toUserListPage());
		} catch (error) {
			console.log({ error });
			showSnack(enqueueSnackbar, "There was an error while deleting the pow user", "error");
		}
	};

	return (
		<Card className={classes.card} data-testid="user-display-card">
			<div className={classes.cardContent}>
				<div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
					<span style={{ justifyContent: "space-between" }} data-testid="card-title">
						<Link variant="h6" to={toUserEditPage(props.user.userPrincipalName)}>
							{props.user.userPrincipalName}
						</Link>
						<div>{props.user.pdpGlobalAdministrator && <h6>PDP Global Administrator</h6>}</div>
					</span>
					<div>
						<div
							style={{
								marginLeft: 6,
								float: "right",
								fontSize: 12,
								paddingTop: 4,
								justifyContent: "flex-end",
								paddingLeft: 6,
								paddingBottom: 10,
							}}
						>
							Created Date: <DateDisplay date={props.user.createdDate} fontSize={12} />
						</div>
						<div className={classes.buttons}>
							<Button
								size="small"
								variant="outlined"
								color={"primary"}
								onClick={() => {
									if (confirm(`Are you sure you want to delete the user: ${props.user.userPrincipalName}?`)) {
										handleDeleteButtonClick();
									}
								}}
								className={classes.deleteButton}
								data-testid="user-delete-button"
							>
								{"Delete User"}
							</Button>
						</div>
					</div>
				</div>
			</div>
		</Card>
	);
};
